module.exports = __webpack_public_path__ + "static/media/view-image-link.ccd299b9.png";